const ACCOUNT_STORAGE_KEYS = ["dashboardStore", "buyDidStore", "aiAssistantStore", "notificationStore"];

export function clearAccountStorage(): void {
    try {
        ACCOUNT_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch {
        // storage blocked (private mode / disabled): nothing was persisted to clear
    }
}
